/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import { useTranslation } from '@lt/localization';

import type { AdjacentTour as AdjacentTourType } from 'src/components/HotelCard/types';
import type { CurrencyType } from 'src/utils/stringUtils';

import InstantConfirmIcon from '@lt/components/icons-react/rebrand/Instant';
import { CurrencyFormat } from '@lt/components';
import HotelCardAvailability from '../../HotelCardAvailability';

import styles from './adjacentTour.module.css';

type AdjacentTourProps = AdjacentTourType & {
  currencyCode: CurrencyType;
  isHotelOnly: boolean;
};

const AdjacentTour: React.FC<AdjacentTourProps> = ({
  price,
  currencyCode,
  datesInfo,
  instantConfirm,
  href,
  availability,
  isHotelOnly,
}) => {
  const { t } = useTranslation();

  return (
    <a className={styles.suggestedItemLink} href={href} target="_blank">
      <div className={styles.row}>
        <div className={styles.price}>
          <div className={styles.prefix}>
            {instantConfirm && (
              <InstantConfirmIcon className={styles.instantConfirmIcon} />
            )}
            <span>{t('filters.prices.from')} </span>
          </div>
          <CurrencyFormat value={price} currencyCode={currencyCode} />
        </div>
      </div>
      <div className={styles.row}>{datesInfo}</div>
      <div className={styles.row}>
        <HotelCardAvailability
          isHotelOnly={isHotelOnly}
          availability={availability}
        />
      </div>
    </a>
  );
};

export default AdjacentTour;
